import { render, staticRenderFns } from "./detail-bak.vue?vue&type=template&id=e56a41ce&scoped=true&"
import script from "./detail-bak.vue?vue&type=script&lang=js&"
export * from "./detail-bak.vue?vue&type=script&lang=js&"
import style0 from "./detail-bak.vue?vue&type=style&index=0&id=e56a41ce&scoped=true&lang=css&"
import style1 from "./detail-bak.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56a41ce",
  null
  
)

export default component.exports